import { createUseStyles } from "react-jss";
import { foregroundColor, alpha, getFontSize } from "../../theme/Mixins";

export default createUseStyles({
    paginatedTable: {
        composes: "paginated-table",
    },
    table: {
        composes: "grid-view",
        background: ({ theme }) =>
            theme.DynamicCss?.HasGridChanges ? {} : alpha("#fff", theme.ControlAlpha),
        color: ({ theme }) => (theme.DynamicCss?.HasGridChanges ? {} : theme.ForegroundColorDark),
        borderCollapse: "collapse",
        borderRadius: ({ theme }) => Math.min(theme.BorderRadius, 20),
        overflow: "hidden",
        boxShadow: ({ theme }) =>
            theme.BorderWidth > 1 && `0 0 0 ${theme.BorderWidth}px ${theme.ControlBorderColor}`,
        margin: ({ theme }) => theme.BorderWidth > 1 && theme.BorderWidth,

        "& td, & th": {
            padding: [[8, 24]],
            border: 0,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 400,
        },
    },
    tableRow: {
        composes: "data-row",
    },
    tableRowAlternate: {
        background: ({ theme }) =>
            theme.DynamicCss?.HasGridChanges
                ? {}
                : alpha(theme.ControlBackground, theme.ControlAlpha),
    },
    tableRowSelectable: {
        composes: "row--selectable",
        cursor: "pointer",
        userSelect: "none",
    },
    tableRowSelected: {
        composes: "row--selected",
        background: ({ theme }) =>
            theme.DynamicCss?.HasGridChanges ? {} : theme.ControlAlpha !== 0 && theme.PrimaryColor,
        color: ({ theme }) =>
            theme.DynamicCss?.HasGridChanges
                ? {}
                : theme.ControlAlpha !== 0 && foregroundColor(theme, theme.PrimaryColor),
    },
    tableRowCheckbox: {
        padding: "6px !important",

        "& span": {
            height: 32,
        },
    },
    tableColumn: {
        background: ({ theme }) => (theme.DynamicCss?.HasGridChanges ? {} : theme.SecondaryColor),
        color: ({ theme }) =>
            theme.DynamicCss?.HasGridChanges ? {} : foregroundColor(theme, theme.SecondaryColor),
        textAlign: "left",
        fontWeight: "normal",
        cursor: "pointer",
        userSelect: "none",
    },
    tableColumnFilter: {
        background: ({ theme }) => (theme.DynamicCss?.HasGridChanges ? {} : theme.SecondaryColor),
        color: ({ theme }) =>
            theme.DynamicCss?.HasGridChanges ? {} : foregroundColor(theme, theme.SecondaryColor),
        padding: "0 6px 8px 6px !important",
    },
    tableColumnFilterInput: {
        display: "block",
        boxSizing: "border-box",
        width: "100%",
        background: "#fff",
        padding: "8px 18px",
        fontSize: "14px",
        outline: 0,
        border: 0,
    },
    sortedColumn: {
        fontWeight: "bolder",
    },
    searchToggleButton: {
        borderRadius: ({ theme }) => theme.BorderRadius,
        margin: 0,
    },
    hiddenItem: {
        display: "none",
    },
    inputWithButton: {
        position: "absolute",
        right: 0,
        top: 0,
        padding: "5px",
        margin: 0,
        border: 0,
        background: "none",
        width: "30px",
        height: "30px",
        cursor: "pointer",
        lineHeight: "35px",
    },
    gridHeaderButtons: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        alignSelf: "stretch",
        width: "100%",
    },
    gridSearchZone: {
        display: "flex",
        alignContent: "right"
    },
    formRow: {
        marginBottom: ({ theme }) => theme.QuestionSpacing?.BetweenComponents
    },
    label: {
        fontSize: ({ theme }) => getFontSize(theme.TextFontSize),
        marginBottom: ({ theme }) => theme.QuestionSpacing?.WithinComponents
    },
    inputField: {
        width: "100%",
        fontSize: ({ theme }) => getFontSize(theme.TextFontSize),
        lineHeight: "22px",
        outline: "none",
        border: "1px solid #D0D3DD",
        borderRadius: 6,
        padding: [[9, 10]],
        boxSizing: "border-box",
        resize: "none",

        "&:active, &:focus": {
            color: "#F68A5A",
        },
    },
});
